<ng-template #ModalAtivaOuDesativa>
  <div class="modal-content">
    <div class="modal-header">
      <a>{{ usuarioParaAtivarOuDesativar.statusUsuario === 'ATIVO' ? 'Desativar Usuário' : 'Ativar Usuário'}}</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>

    <div class="modal-body text-center p-5">
      <p class="p__div">{{ usuarioParaAtivarOuDesativar.statusUsuario === 'ATIVO' ? 'Deseja Desativar o Usuário' :
        'Deseja Ativar o Usuário'}} "{{usuarioParaAtivarOuDesativar.nome}}" ?</p>
      <div class="div-button mt-5">
        <button (click)="fecharModal()" class="button-secondary">
          Cancelar
        </button>
        <button (click)="aoAtivarOuDesativar()" class="button-primary">
          {{ usuarioParaAtivarOuDesativar.statusUsuario === 'ATIVO' ? 'Desativar Usuário' : 'Ativar Usuário'}}
        </button>
      </div>
    </div>
  </div>
</ng-template>